import React, { useCallback, useRef, useState } from "react";
import DataGrid, {
  Column,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Summary,
  TotalItem,
} from "devextreme-react/cjs/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { Card } from "react-bootstrap";
import { getAllGoldProductInventoryData } from "modules/inward/gold-product-inventory/services/gold-product-inventory.service";
import { HttpStatus, UpdateInwardDataIds } from "modules/core";
import { updateGoldAndDiamondInventoryRecords } from "utils/inward";
import notistack from "modules/core/notistack";
import { UpdateInventoryReturnDataIds } from "modules/inward/diamond-product-inventory/model";

const GoldInventorySNMCC = () => {
  let setSelectedRows: Array<number> = [];
  const dataGridRef = useRef<DataGrid>(null);

  const dataSource = new CustomStore({
    key: 'id',
    load: async (loadOptions) => {
      try {
        const { searchValue, skip, take } = loadOptions;
                const parameterList = new URLSearchParams();
                if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                if (typeof take === 'number') parameterList.append('take', take.toString());
                const search = JSON.parse(JSON.stringify(loadOptions));
                for (const [key, value] of Object.entries(search)) {
                    parameterList.append(key, JSON.stringify(value));
                }
                if (searchValue) {
                    parameterList.append("search", searchValue);
                }
        parameterList.append("MaterialType", "gold");
        parameterList.append("IsSNMCC", "true");
        parameterList.append("IsReceived", "true");
        const response = await getAllGoldProductInventoryData(parameterList);
        // return {
        //   data: response?.data || [],
        //   totalCount: response?.data.length || 0,
        // };
        return response;
      } catch (error) {
        console.error("Data loading error:", error);
        return { data: [], totalCount: 0 };
      }
    }
  });

  const handleSelectionChange = (e: any) => {
    setSelectedRows = e.selectedRowsData.map((item: any) => item.id);
  };

  const renderSerialNumber = useCallback((cellData: any) => {
    const rowIndex = cellData.rowIndex + 1 + cellData.component.pageIndex() * cellData.component.pageSize();
    return <span>{rowIndex}</span>;
  }, []);

  const updateDiamondAndGoldInventory = async () => {
    try {
      if (setSelectedRows.length > 0) {
        const model = new UpdateInventoryReturnDataIds();
        model.returnToMayaveProductIdList = setSelectedRows;
        const response = await updateGoldAndDiamondInventoryRecords(model);
        if (response.status === HttpStatus.Success) {
          dataGridRef.current?.instance.clearSelection();
          dataGridRef.current?.instance.refresh();
          notistack.notifyFromApi(response);
        }
      } else {
        notistack.warning("Please Select Product");
      }
    } catch (error) {
      console.error("Failed to fetch inward Data:", error);
    } finally {
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="m-0">Memo Gold Product Inventory</h5>
              <button onClick={updateDiamondAndGoldInventory} className="submit-btn">
                Return
              </button>

            </Card.Header>
            <Card.Body className="pt-0">
              <DataGrid
                dataSource={dataSource}
                remoteOperations={{ groupPaging: true }}
                showRowLines={true}
                keyExpr="id"
                ref={dataGridRef}
                showBorders={true}
                columnAutoWidth={true}
                onSelectionChanged={handleSelectionChange}
                onContentReady={(e) => {
                  const hasData = e.component.totalCount() > 0;
                  e.component.option("pager.visible", hasData);
                  e.component.option("paging.visible", hasData);
                }}
                onCellPrepared={(e) => {
                  if (['data', 'header'].includes(e.rowType)) {
                    e.cellElement.style.textAlign = 'center';
                  }
                }}
              >
                <Scrolling
                  mode='standard'
                  useNative={true}
                  scrollByContent={true}
                  scrollByThumb={true}
                />
                <Selection
                  mode="multiple"
                />
                <Pager

                  showPageSizeSelector={true}
                  allowedPageSizes={[10, 25, 50, 100]}
                  showNavigationButtons={true}
                  displayMode="full"
                  showInfo={true}
                />
                <Summary>
                  <TotalItem
                  // column="Sr.No."
                  // summaryType="count"
                  // displayFormat="Total: {0}"
                  />
                </Summary>
                <Paging defaultPageSize={10} />
                <SearchPanel visible width={240} placeholder="Search..." />

                <Column
                  cssClass="text-center" caption="Sr.No."
                  dataType="number"
                  alignment="center"
                  cellRender={renderSerialNumber}
                />

                <Column
                  allowFiltering={true}
                  dataField="storeCode"
                  caption="Store Code"
                  dataType="string"
                  width={150}
                />
                <Column
                  allowFiltering={true}
                  dataField="bagNo"
                  caption="BagNo."
                  dataType="string"
                  width={150}
                />
                <Column
                  allowFiltering={true}
                  dataField="styleNo"
                  caption="Style Number"
                  dataType="string"
                  width={150}
                />
                <Column
                  allowFiltering={true}
                  dataField="categoryName"
                  caption="Category Name"
                  dataType="string"
                  width={150}
                />
                <Column
                  allowFiltering={false}
                  dataField="metalKT"
                  caption="Metal KT"
                  dataType="string"
                  width={150}
                />

                <Column
                  allowFiltering={false}
                  dataField="netWt"
                  caption="Net Weight"
                  format="#,##0.000"
                  dataType="string"
                  width={150}
                />
                <Column
                  allowFiltering={false}
                  dataField="grossWt"
                  caption="Gross Weight"
                  format="#,##0.000"
                  dataType="string"
                  width={150}
                />

                <Column
                  allowFiltering={true}
                  dataField="huid"
                  caption="HUID"
                  dataType="string"
                  width={150}
                />
                <Column
                  allowFiltering={false}
                  dataField="colorStonePrice"
                  caption="Color Stone Price"
                  format="#,##0.00"
                  dataType="string"
                  width={150}
                />

                <Column
                  allowFiltering={true}
                  dataField="complexityName"
                  caption="Complexity Name"
                  dataType="string"
                  width={150}
                />
                <Column
                  allowFiltering={true}
                  dataField="complexityValue"
                  caption="Complexity Value"
                  dataType="string"
                  width={150}
                />
              </DataGrid>
            </Card.Body>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};
export default GoldInventorySNMCC;
